<template>
  <div
    class="notification"
    @click="handleClick">
    <img
      class="notification__logo"
      src="/images/app_announce/app-icon.svg"
      alt="SkyCoach Logo">

    <p class="notification__p">
      SkyCoach App is now available 🤩
    </p>

    <div class="notification__buttons">
      <appstore-button
        ref="app-appstore-button"
        class="notification__app-appstore-button"
        @close="$emit('close')" />

      <googleplay-button
        ref="app-google-play-button"
        class="notification__app-google-play-button"
        @close="$emit('close')" />
    </div>

    <button
      class="notification__close"
      @click.stop="$emit('close')">
      <div class="shape-cross" />
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppstoreButton from 'Components/ui/AppMarkets/AppstoreButton.vue';
import GoogleplayButton from 'Components/ui/AppMarkets/GoogleplayButton.vue';

export default {
  name: 'AppAvailableNotification',

  components: {
    GoogleplayButton,
    AppstoreButton,
  },

  computed: {
    ...mapState(['userDevice']),
  },

  methods: {
    handleClick() {
      if (this.userDevice.innerWidth > 767) {
        return;
      }

      if (this.userDevice.platformFromUA === 'android' && this.$refs['app-google-play-button']?.$el) {
        this.$refs['app-google-play-button']?.$el?.click();
      } else if (this.userDevice.platformFromUA === 'ios' && this.$refs['app-appstore-button']?.$el) {
        this.$refs['app-appstore-button']?.$el?.click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  height: 72px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle, rgba($color--basic-purple, .5) 0%, $color--basic-black 80%);
  padding: 0 var(--padding);
  position: relative;
}

.notification__logo {
  width: 40px;
  height: 40px;
  margin-right: 24px;
  margin-left: auto;
}

.notification__p {
  font-size: 19px;
  margin-right: 40px;
}

.notification__buttons {
  display: flex;
}

.notification__app-appstore-button,
.notification__app-google-play-button {
  --color: #{$color--basic-black};
  --background: #{$color--basic-white};

  &:hover {
    --color: #{$color--basic-white};
    --background: #{$color--basic-black};
  }

  &:not(:last-child) {
    margin-right: 16px;
  }
}

.notification__close {
  margin-left: auto;
  border: none;
  background: none;
  padding: 0;
}

.shape-cross {
  width: 15px;
  height: 15px;
}

@media screen and #{$screen-less-than-768} {
  .notification__buttons {
    display: none;
  }
}

@media screen and #{$screen-less-than-640} {
  .notification {
    padding: 0 66px;
    background: radial-gradient(circle, rgba($color--basic-purple, .5) 0%, $color--basic-black 95%);
  }

  .notification__logo {
    margin-right: 16px;
  }

  .notification__p {
    font-size: 15px;
    margin-right: unset;
  }

  .shape-cross {
    --shape-color: #{$color--basic-blue};

    opacity: .5;
    position: absolute;
    top: 13px;
    right: 13px;
  }
}
</style>
